import React from 'react';
import { render } from '@testing-library/react';
import ConflictScreen from './ConflictScreen';

const translations = {
  channelEmailAddress: 'email address',
  channelMobile: 'mobile phone number',
  conflictInUseHtml:
    'The %{channel} <b>%{value}</b> you provided is <b>already being used by another contact</b> on our platform.',
  conflictCannotAdd:
    'Unfortunately we will not be able to add this %{channel} to your account right now.',
  conflictContactAdvisor: 'Please contact the Service Advisor to make this update.',
  continueToPortal: 'Continue to Portal',
  previousPage: 'Previous Page',
  conflictWhyTitle: 'Why am I seeing this?',
  conflictWhyBody: 'You are probably seeing this because you already have an account.',
  helpDeskMultipleAccounts: 'Help Desk - Multiple Accounts',
};

describe('ConflictScreen', () => {
  const noop = () => {};

  it('interpolates the channel and value into the localized copy', () => {
    const { container, getByText } = render(
      <ConflictScreen
        requestType="email"
        value="taken@example.com"
        onBack={noop}
        onContinue={noop}
        translations={translations}
      />,
    );

    expect(container.textContent).toContain(
      'The email address taken@example.com you provided is',
    );
    expect(
      getByText(
        'Unfortunately we will not be able to add this email address to your account right now.',
      ),
    ).toBeInTheDocument();
  });

  it('escapes a malicious value instead of injecting markup', () => {
    const { container } = render(
      <ConflictScreen
        requestType="email"
        value="<img src=x onerror=alert(1)>"
        onBack={noop}
        onContinue={noop}
        translations={translations}
      />,
    );

    // The value must be rendered as text, never as a live element.
    expect(container.querySelector('img')).toBeNull();
    expect(container.textContent).toContain('<img src=x onerror=alert(1)>');
  });
});
